import { JITMeetConferenceOptions } from '../../../domain/models/jit-meet/conference/jit-meet-conference.model';

/**
 * Configuración predeterminada de las conferencias JIT Meet.
 *
 * Jitsi se utiliza exclusivamente como motor de videoconferencia.
 * La experiencia visual y los controles pertenecen a JIT Meet.
 *
 * Versión de infraestructura validada:
 * Docker Jitsi Meet stable-11031.
 */
export const JIT_MEET_DEFAULT_CONFERENCE_OPTIONS:
  Readonly<JITMeetConferenceOptions> = {
  language: 'es',

  audioMuted: false,
  videoMuted: false,

  width: '100%',
  height: '100%',

  configOverwrite: {
    /**
     * stable-11031 utiliza prejoinConfig.
     * prejoinPageEnabled es una configuración heredada y fue retirada.
     *
     * Con enabled: false, el participante debe ingresar directamente
     * a la conferencia sin pasar por la pantalla:
     * "Entrar a la reunión".
     */
    prejoinConfig: {
      enabled: false,
      hideDisplayName: true,
      hideExtraJoinButtons: ['no-audio', 'by-phone'],
      preCallTestEnabled: false,
      showHangUp: false,
    },

    /**
     * Evita páginas y promociones externas de Jitsi.
     */
    enableWelcomePage: false,
    disableDeepLinking: true,

    /**
     * Estado inicial de los dispositivos.
     *
     * Estos valores posteriormente son sobrescritos por mergeOptions()
     * cuando el consumidor envía audioMuted o videoMuted.
     */
    startWithAudioMuted: false,
    startWithVideoMuted: false,

    /**
     * JIT Meet proporciona su propia toolbar.
     *
     * Un arreglo vacío evita que Jitsi renderice los controles nativos.
     */
    toolbarButtons: [],

    /**
     * JIT Meet administra sus propios mensajes y estados.
     *
     * Es importante usar [] y no null/undefined, porque un valor falsy
     * habilita todas las notificaciones de Jitsi.
     */
    notifications: [],

    /**
     * Oculta indicadores y opciones administrativas que no deben formar
     * parte de la experiencia clínica.
     */
    disableModeratorIndicator: true,

    hideConferenceSubject: true,
    hideConferenceTimer: true,
    hideDisplayName: true,

    participantsPane: {
      hideModeratorSettingsTab: true,
      hideMoreActionsButton: true,
      hideMuteAllButton: true,
    },

    securityUi: {
      hideLobbyButton: true,
    },

    /**
     * El lobby no debe agregar controles ni chat propios dentro del iframe.
     *
     * Si el servidor habilita un lobby para algún flujo futuro,
     * el ingreso podrá realizarse automáticamente.
     */
    lobby: {
      autoKnock: true,
      enableChat: false,
    },
  },

  /**
   * Configuración visual heredada de interface_config.
   *
   * Se conserva como capa complementaria porque algunas propiedades
   * de marca siguen siendo consumidas por la interfaz web embebida.
   */
  interfaceConfigOverwrite: {
    APP_NAME: 'JIT Meet',
    NATIVE_APP_NAME: 'JIT Meet',
    PROVIDER_NAME: 'JIT Consultings',

    SHOW_JITSI_WATERMARK: false,
    SHOW_WATERMARK_FOR_GUESTS: false,
    SHOW_BRAND_WATERMARK: false,
    SHOW_POWERED_BY: false,
    SHOW_PROMOTIONAL_CLOSE_PAGE: false,

    HIDE_INVITE_MORE_HEADER: true,
    DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,

    DEFAULT_REMOTE_DISPLAY_NAME: 'Paciente',
    DEFAULT_LOCAL_DISPLAY_NAME: 'Profesional',
  },
};